import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignalRService, ConnectionState } from '../../services/signalr.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-connection-status',
    imports: [CommonModule],
    templateUrl: './connection-status.component.html',
    styleUrls: ['./connection-status.component.css']
})
export class ConnectionStatusComponent implements OnInit, OnDestroy {
  connectionState: ConnectionState = ConnectionState.Disconnected;
  ConnectionState = ConnectionState; // Make enum available in template
  showTooltip = false;
  
  private destroy$ = new Subject<void>();

  constructor(private signalRService: SignalRService) {}

  ngOnInit(): void {
    this.signalRService.connectionState
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.connectionState = state;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getStatusClass(): string {
    switch (this.connectionState) {
      case ConnectionState.Connected:
        return 'status-connected';
      case ConnectionState.Connecting:
      case ConnectionState.Reconnecting:
        return 'status-reconnecting';
      case ConnectionState.Disconnected:
      default:
        return 'status-disconnected';
    }
  }

  getStatusIcon(): string {
    switch (this.connectionState) {
      case ConnectionState.Connected:
        return '●'; // Filled circle
      case ConnectionState.Connecting:
      case ConnectionState.Reconnecting:
        return '◐'; // Half-filled circle
      case ConnectionState.Disconnected:
      default:
        return '○'; // Empty circle
    }
  }

  getStatusText(): string {
    switch (this.connectionState) {
      case ConnectionState.Connected:
        return 'Real-time updates active';
      case ConnectionState.Connecting:
        return 'Connecting to server...';
      case ConnectionState.Reconnecting:
        return 'Reconnecting...';
      case ConnectionState.Disconnected:
      default:
        return 'Real-time updates offline';
    }
  }
}
